<template>
  <page>
    <v-flex xs12>
      <form data-vv-scope="filters">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="filters.jobId"
                          :label="labels.jobId"
                          :error-messages="errors.collect('filters.jobId')"
                          data-vv-name="filters.jobId"
                          :data-vv-as="labels.jobId"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="filters.jobName"
                          :label="labels.jobName"
                          :error-messages="errors.collect('filters.jobName')"
                          data-vv-name="filters.jobName"
                          :data-vv-as="labels.jobName"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <cal-picker
                          v-model="filters.jobStart"
                          :label="labels.jobStart"
                          :data-vv-as="labels.jobStart"
                          data-vv-name="filters.jobStart"
                        ></cal-picker>
                      </v-flex>
                      <v-flex md4 xs12>
                        <cal-picker
                          v-model="filters.jobEnd"
                          :label="labels.jobEnd"
                          :data-vv-as="labels.jobEnd"
                          data-vv-name="filters.jobEnd"
                        ></cal-picker>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="filters.createdBy"
                          :label="labels.createdBy"
                          :error-messages="errors.collect('filters.createdBy')"
                          data-vv-name="filters.createdBy"
                          :data-vv-as="labels.createdBy"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-autocomplete
                          :items="batchStatus"
                          v-model="filters.jobStatus"
                          :label="labels.jobStatus"
                          item-text="label"
                          item-value="value"
                          data-vv-name="filters.jobStatus"
                          :data-vv-as="labels.jobStatus"
                          :error-messages="errors.collect('filters.jobStatus')"
                          clearable
                        ></v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
    <v-card>
      <v-flex xs12>
        <v-flex xs12 class="mt-1">
          <message :messages="messages"></message>
        </v-flex>
        <v-card>
          <v-card-title>
            <v-layout row wrap>
              <v-spacer></v-spacer>
              <div>
                <v-btn color="primary" @click.prevent="doShowSettings">
                  Settings
                  <v-icon right>mdi-settings</v-icon>
                </v-btn>
              </div>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :footer-props="{ 'items-per-page-options': itemsPerPage }"
              :loading="loading"
              :server-items-length="totalItems"
              :no-data-text="noDataText"
              v-bind:options.sync="pagination"
            >
              <template v-slot:item="row">
                <tr>
                  <td class="text-xs-left">{{ row.item.jobId }}</td>
                  <td class="text-xs-left">{{ row.item.jobName }}</td>
                  <td class="text-xs-left">{{ row.item.jobStart ? formatDisplayDateTime(row.item.jobStart) : '-' }}</td>
                  <td class="text-xs-left">{{ row.item.jobEnd ? formatDisplayDateTime(row.item.jobEnd) : '-' }}</td>
                  <td class="text-xs-left">{{ row.item.createdBy }}</td>
                  <td class="text-xs-left">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" :color="row.item.color">{{ row.item.icon }}</v-icon>
                      </template>
                      <span>{{ row.item.desc }}</span>
                    </v-tooltip>
                  </td>
                  <td class="table-action-header">
                    <table-action
                      :batch_error="showError(row.item)"
                      @batch_error="doBatchError(row.item)"
                      :batch_param="true"
                      @batch_param="doBatchParam(row.item)"
                      :remove="canRemove(row.item)"
                      @remove="doRemove('remove', row.item)"
                      :cancel="canCancel(row.item)"
                      @cancel="doRemove('cancel', row.item)"
                      :terminate="canTerminate(row.item)"
                      @terminate="doRemove('terminate', row.item)"
                      :retry="canRetry(row.item)"
                      @retry="doRetry(row.item)"
                      :unscheduled="canUnscheduled(row.item)"
                      @unscheduled="doUnscheduled('unscheduled', row.item)"
                    ></table-action>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-card>
    <v-dialog v-model="showBatchError" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-warning</v-icon>
          <v-toolbar-title>Job Error</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="selectedJob" class="pb-3">
            {{ selectedJob.jobMessage }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showBatchError = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showBatchParam" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>Run Time Parameters</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="selectedJob" class="pb-3">
            <pre>{{ JSON.parse(selectedJob.jobKeys) }}</pre>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showBatchParam = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <warning v-model="promptRemove" @ok="proceedRemove">{{ getWarningText() }}</warning>

    <v-dialog v-model="showSettings" width="1000px">
      <card>
        <BatchManagerJobSettings v-if="showSettings === true"/>
      </card>
    </v-dialog>
  </page>
</template>
<script>
import { formatDisplayDate, formatDisplayDateTime } from '@/utils/date'
import http, { expandURI, filterQuery } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import clone from 'clone'
import { batchManagerMixin } from '@/mixins/common/batchManagerMixin'
import BatchManagerJobSettings from './BatchManagerJobSettings'

export default {
  data() {
    return {
      selectedJob: undefined,
      totalItems: 0,
      headers: [
        { text: 'Job Id', value: 'jobId' },
        { text: 'Job Name', value: 'jobName' },
        { text: 'Requested Date', value: 'jobStart' },
        { text: 'Completed Date', value: 'jobEnd' },
        { text: 'Requested By', value: 'createdBy' },
        { text: 'Status ', value: 'jobStatus' },
        TableConst.tableActionHeader
      ],
      labels: {
        jobId: 'Job ID',
        jobName: 'Job Name',
        jobStatus: 'Job Status',
        jobStart: 'Requested Date',
        jobEnd: 'Completed Date',
        createdBy: 'Requested By'
      },
      filters: {
        jobId: null,
        jobName: null,
        jobStatus: null,
        jobStart: null,
        jobEnd: null,
        createdBy: null,
        fromNotif: false
      },
      pagination: {
        sortDesc: [false],
        page: 1
      },
      showBatchError: false,
      showBatchParam: false,
      showSettings: false
    }
  },
  methods: {
    async batchJobInit() {
      this.resetMessages()
      const apiUrl = this.$store.state.app.menu.batchJob
      if (apiUrl) {
        try {
          const result = await http.get(expandURI(apiUrl))
          this.menu = extractMenu(result.data._links)
          this.fetchBatchJobs()
        } catch (error) {
          this.$toast.error('There was an unexpected error during initialization.')
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async fetchBatchJobs(options) {
      const apiURI = this.batchmenu.bchMngJobHistory
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let massageFilters = clone(this.filters)
          massageFilters.jobStart = this.formatDisplayDate(massageFilters.jobStart)
          massageFilters.jobEnd = this.formatDisplayDate(massageFilters.jobEnd)
          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result) {
            const { data } = result
            this.items = []
            if (data) {
              this.totalItems = result.data.totalElements
              this.$set(this, 'items', data.data)
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doBatchError(job) {
      this.selectedJob = job
      this.showBatchError = true
    },
    doBatchParam(job) {
      this.selectedJob = job
      this.showBatchParam = true
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('filters').then(result => {
        if (result) {
          this.fetchBatchJobs(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    formatDisplayDate(myDate) {
      return formatDisplayDate(myDate)
    },
    formatDisplayDateTime(myDate) {
      return formatDisplayDateTime(myDate)
    },
    doClearFilters() {
      this.filters.jobId = null
      this.filters.jobStatus = null
      this.filters.jobName = null
      this.filters.jobStart = null
      this.filters.jobEnd = null
      this.filters.createdBy = null
      this.fetchBatchJobs(false)
    },
    showError(data) {
      return data.jobStatus === 'FP' && (data.jobMessage !== undefined && data.jobMessage !== null && data.jobMessage !== '')
    },
    doShowSettings() {
      this.showSettings = true
    }
  },
  watch: {
    pagination: function(value) {
      this.fetchBatchJobs(false)
    },
    '$store.state.user.notification.bchStatus': function(value) {
      if (value) {
        this.promptRemove = false
        this.fetchBatchJobs(false)
      }
    },
    '$store.state.user.notification.bchId': function(value) {
      if (value) {
        this.promptRemove = false
        this.fetchBatchJobs(false)
      }
    }
  },
  mounted() {
    this.batchJobInit()
    this.getJobStatus()
    this.fetchBatchJobs(false)
  },
  computed: {
  },
  components: {
    BatchManagerJobSettings
  },
  mixins: [TableConst.default, MessageMixin, batchManagerMixin]
}
</script>

<style lang="scss"></style>
